import {StyleSheet} from "react-native";
import {STYLE_VARS} from "../../constants/style-vars";

export const sportStyled = StyleSheet.create({
    container: {
        paddingHorizontal: 20,
    },
    headerWrapper: {
        paddingHorizontal: 20,
        borderBottomColor: STYLE_VARS.fccDarkGrey, 
        borderBottomWidth: 0.5,
    }
})